<template>
  <div class="topbar">
    <div class="container">
      <div class="topbar__block">
        <TopbarLocation class="topbar__select"></TopbarLocation>
        <TopbarLanguage class="topbar__select"></TopbarLanguage>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TopbarLocation from './TopbarLocation.vue';
import TopbarLanguage from './TopbarLanguage.vue';
</script>

<style lang="scss" scoped>
.topbar {
  background-color: #333f48;

  &__select {
    font-family: Eurostile, sans-serif;
    color: white;
    display: flex;
    align-items: center;
    width: auto;
    height: 32px;
    :deep(.input-select__icon) {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    :deep(.input-select__toggle) {
      width: 16px;
      height: 16px;
      margin-left: 4px;
    }
    :deep(.input-select__input) {
      height: auto;
      padding: 0;
      border: 0;
      background-color: transparent;
      text-transform: uppercase;
      font-size: 11px;
      font-weight: 700;
      line-height: 11px;
      letter-spacing: 0.12em;
      text-align: center;
    }
    :deep(button) {
      position: static;
      transform: none;
    }
    :deep(.input-select__menu) {
      top: unset;
      bottom: 0;
      left: unset;
      padding-top: 0;
      transform: translateY(100%);
      color: #333f48;
    }
  }

  &__block {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .topbar {
      &__select {
        &:not(:first-child) {
          margin-left: 24px;
        }
      }
    }
  }
}
</style>
